import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

export default function Comments() {
  const [comments, setComments] = useState([]);

  const fetchComments = async () => {
    try {
      const res = await axios.get(`${API_URL}/comments`);
      setComments(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this comment?")) return;
    try {
      await axios.delete(`${API_URL}/comments/${id}`);
      setComments((p) => p.filter((c) => c.id !== id));
    } catch (err) {
      console.error(err);
      alert("Delete failed");
    }
  };

  return (
    <div className="p-6">
      {/* Header Card */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 mb-6 border border-white/20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-3xl font-bold text-white flex items-center gap-3">
              <span className="text-4xl">💬</span> User Comments
            </h2>
            <p className="text-cyan-200 mt-1">Manage customer reviews and feedback</p>
          </div>
          
          <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl px-5 py-3 text-white">
            <p className="text-sm opacity-80">Total Comments</p>
            <p className="text-2xl font-bold">{comments.length}</p>
          </div>
        </div>
      </div>

      {/* Comments Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {comments.length === 0 ? (
          <div className="col-span-full text-center py-12 text-white/50">
            <div className="text-5xl mb-3">💭</div>
            <p>No comments yet</p>
          </div>
        ) : (
          comments.map((c) => (
            <div key={c.id} className="bg-white/10 backdrop-blur-xl rounded-2xl p-5 border border-white/20
              hover:bg-white/15 transition-all duration-300 group">
              {/* Header */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  {c.image ? (
                    <img src={c.image} alt={c.name} className="w-14 h-14 object-cover rounded-full border-2 border-cyan-400" />
                  ) : (
                    <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full 
                      flex items-center justify-center text-white text-xl font-bold">
                      {c.name?.charAt(0)?.toUpperCase() || '?'}
                    </div>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-white truncate">{c.name}</h3>
                    <div className="flex items-center gap-1 text-yellow-400">
                      <span className="text-lg">{c.rating}</span>
                      <span>★</span>
                    </div>
                  </div>
                  <p className="text-xs text-white/50 mt-1">
                    {new Date(c.createdAt).toLocaleDateString('en-US', {
                      year: 'numeric', month: 'short', day: 'numeric'
                    })}
                  </p>
                </div>
              </div>

              {/* Message */}
              <div className="mt-4 p-3 bg-white/5 rounded-xl">
                <p className="text-white/80 text-sm leading-relaxed">{c.message}</p>
              </div>

              {/* Rating Stars */}
              <div className="mt-3 text-yellow-400 text-lg">
                {"★".repeat(c.rating)}{"☆".repeat(5 - c.rating)}
              </div>

              {/* Delete Button */}
              <div className="mt-4 pt-4 border-t border-white/10">
                <button 
                  onClick={() => handleDelete(c.id)} 
                  className="w-full bg-red-500/20 hover:bg-red-500 text-red-300 hover:text-white 
                    px-4 py-2 rounded-lg transition-all duration-300 flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Delete Comment
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
